import { logger } from 'common-ui';
import { reloadAuthToken } from '../../atoms/authAtom';
import { fetchCart } from './fetchCart';
import type { AuthDetails } from 'tsconfig/types';

export async function handleExistingCartId(authAtomState: AuthDetails | null): Promise<void> {
  try {
    if (!authAtomState?.publicCsrf) {
      await reloadAuthToken();
    }

    await fetchCart();
  } catch (error) {
    logger.error('Error handling existing cart ID:', error);
    throw error;
  }
}
